import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Truck, MapPin, Users, Settings, Plus } from "lucide-react";
import api, { apiErrorMessage } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { DELIVERY } from "@/constants/testIds";

function dollars(c) { return `$${((c || 0) / 100).toFixed(2)}`; }

const CARDS = [
  { to: "/admin/delivery/dispatch", icon: Truck, label: "Dispatch board", blurb: "Pending orders, on-shift drivers, assign in one click." },
  { to: "/admin/delivery/drivers",  icon: Users, label: "Drivers", blurb: "Profiles, status, background check, lifetime stats." },
  { to: "/admin/delivery/zones",    icon: MapPin, label: "Zones", blurb: "Service areas + zone-level fee overrides." },
  { to: "/admin/delivery/config",   icon: Settings, label: "Fee config", blurb: "Base + per-mile. master_admin only." },
  { to: "/admin/delivery/earnings", icon: Truck, label: "Earnings ledger", blurb: "Approve, void, payout-ready balance per driver." },
];

export default function AdminDeliveryHome() {
  const [stats, setStats] = useState(null);
  useEffect(() => { api.get("/admin/delivery/dispatch").then((r) => setStats(r.data)).catch(() => {}); }, []);

  return (
    <div data-testid={DELIVERY.adminHome} className="space-y-8">
      <header className="fade-up">
        <div className="eyebrow">Delivery admin</div>
        <h1 className="headline-xl">Delivery command center</h1>
        <p className="text-lifted-dim mt-2 max-w-2xl text-sm">Drivers, orders, zones and fee config — same-day Lifted Supplies.</p>
      </header>

      {stats && (
        <section className="grid grid-cols-2 sm:grid-cols-4 gap-3">
          <Stat label="Pending orders" value={stats.pending.length} />
          <Stat label="Active deliveries" value={stats.active.length} />
          <Stat label="Active drivers" value={stats.drivers.length} />
          <Stat label="On-shift" value={stats.drivers.filter(d => d.availability === "on_shift").length} />
        </section>
      )}

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
        {CARDS.map((c, i) => (
          <Link key={c.to} to={c.to} className={`glass-panel p-6 fade-up delay-${(i%5)+1} hover:-translate-y-1 hover:border-lifted-green/30 transition-transform`}>
            <div className="flex items-center gap-4">
              <div className="h-11 w-11 rounded-xl border border-lifted-green/30 bg-lifted-green/10 text-lifted-green flex items-center justify-center">
                <c.icon className="h-5 w-5" />
              </div>
              <div>
                <div className="font-anton text-xl uppercase">{c.label}</div>
                <div className="text-sm text-lifted-dim">{c.blurb}</div>
              </div>
            </div>
          </Link>
        ))}
      </div>
    </div>
  );
}

function Stat({ label, value }) {
  return (
    <div className="glass-panel p-4">
      <div className="eyebrow !text-lifted-text-dim">{label}</div>
      <div className="mt-1 font-anton text-2xl text-lifted-text">{value}</div>
    </div>
  );
}
